function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.04526 1.00001L4.33038 2.6288",
  stroke: "#932D69",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.71338 2.61823L2.85905 3.66826",
  stroke: "#932D69",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.5 5.13971L2.13488 5.13979",
  stroke: "#932D69",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0469 11.72H17.1711V23C17.1711 23.5522 16.7233 24 16.1711 24H13.0469C12.4946 24 12.0469 23.5522 12.0469 23V11.72Z",
  fill: "#FF8CBD"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5913 8.28338C11.254 8.28338 7.79392 5.63889 7.79392 2.3761L14.5913 8.28338Z",
  fill: "#FF8CBD"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.935 2.91296C17.0547 2.91296 14.0684 5.31064 14.0684 8.2689L19.935 2.91296Z",
  fill: "#FF8CBD"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M7.79392 2.3761C11.1312 2.3761 14.5913 5.02059 14.5913 8.28338L7.79392 2.3761Z",
  fill: "#FF8CBD"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M20.974 11.3725H4.02588V20.7454C4.02588 21.1005 4.16323 21.4411 4.40773 21.6922C4.65222 21.9433 4.98382 22.0844 5.32958 22.0844H19.6703C20.0161 22.0844 20.3477 21.9433 20.5922 21.6922C20.8367 21.4411 20.974 21.1005 20.974 20.7454V11.3725Z",
  stroke: "#26282C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M20.974 7.35596H4.02587C3.68011 7.35596 3.34851 7.49703 3.10401 7.74814C2.85952 7.99924 2.72217 8.33982 2.72217 8.69494V10.7034C2.72217 10.881 2.79085 11.0513 2.91309 11.1768C3.03534 11.3024 3.20114 11.3729 3.37402 11.3729H21.6259C21.7988 11.3729 21.9646 11.3024 22.0868 11.1768C22.2091 11.0513 22.2777 10.881 22.2777 10.7034V8.69494C22.2777 8.33982 22.1404 7.99924 21.8959 7.74814C21.6514 7.49703 21.3198 7.35596 20.974 7.35596Z",
  stroke: "#26282C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8481 7.35593C8.9678 7.35593 5.98145 4.95826 5.98145 2",
  stroke: "#26282C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M5.98145 2C8.86176 2 11.8481 4.39767 11.8481 7.35593",
  stroke: "#26282C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1519 7.35593C16.0322 7.35593 19.0185 4.95826 19.0185 2",
  stroke: "#26282C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0185 2C16.1382 2 13.1519 4.39767 13.1519 7.35593",
  stroke: "#26282C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4555 7.35596H10.5444V22.0848H14.4555V7.35596Z",
  stroke: "#26282C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgGift(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.7a2f4c23.svg";
export { ForwardRef as ReactComponent };